// Libraries
import { FormControl, FormLabel, Switch } from '@chakra-ui/react';
// Types
import { SwitchControlProps } from './SwitchControl.types';

/**
 * A switch control component.
 *
 * @component
 * @param {SwitchControlProps} props - The props for the SwitchControl component.
 * @param {string} props.label - The label to be displayed next to the switch.
 * @param {boolean} props.isChecked - The current state of the switch. Set to `true` for checked, `false` for unchecked.
 * @param {boolean} props.isDisabled - Optional flag indicating whether the component is disabled.
 * @param {Function} props.onChange - A callback function to handle the change event when the switch state is toggled.
 * @param {Function} props.formControlProps - All props from FormControl element.
 * @returns {ReactElement} The SwitchControl component.
 */
export const SwitchControl = ({
  label,
  isChecked,
  isDisabled = false,
  onChange,
  ...formControlProps
}: SwitchControlProps) => {
  return (
    <FormControl display='flex' alignItems='center' gap={2} {...formControlProps}>
      <FormLabel m={0} fontSize='m' color='text.base' fontWeight='normal'>
        {label}
      </FormLabel>
      <Switch isChecked={isChecked} onChange={onChange} isDisabled={isDisabled} />
    </FormControl>
  );
};
